import {useEffect} from "react";


export default class Subscription {
    listeners: Set<() => void> = new Set();

    /**
     * Subscribes a listener function to an event or state change.
     *
     * @param {Function} listener - A function to be invoked when the event or state change occurs.
     * @return {Function} A function that, when called, unsubscribes the given listener.
     */
    subscribe(listener: () => void): () => void {
        this.listeners.add(listener);
        return () => this.listeners.delete(listener);
    }

    notify() {
        this.listeners.forEach(listener => listener());
    }
}

export function useListener(subscription: Subscription, listener: () => void) {
    useEffect(() => {
        return subscription.subscribe(listener);
    }, [subscription, listener]);
}
